import { GetMonthStatisticsResponse, TaskListMode } from 'compliance-api';
// import dayjs from 'dayjs';
import { FC } from 'react';
import { useTasksListQuery } from '@/modules/common/queries/tasks.ts';
import { AnimatedNumbersSet } from 'ui';

interface CommonStatisticProps {
  data: GetMonthStatisticsResponse | undefined;
  isDataLoading: boolean;
}

const CommonStatistic: FC<CommonStatisticProps> = ({ isDataLoading }) => {
  // const fromDate = dayjs().startOf('month').toISOString();
  // const toDate = dayjs().endOf('month').toISOString();

  const { data: todoData, isLoading: isLoadingTodo } = useTasksListQuery({
    page: 1,
    page_size: 1000,
    mode: TaskListMode.Todo,
    // from_date: fromDate,
    // to_date: toDate,
  });

  const { data: overdueData, isLoading: isLoadingOverdue } = useTasksListQuery({
    page: 1,
    page_size: 1000,
    mode: TaskListMode.Overdue,
    // from_date: fromDate,
    // to_date: toDate,
  });

  const { data: upcomingData, isLoading: isLoadingUpcoming } = useTasksListQuery({
    page: 1,
    page_size: 1000,
    mode: TaskListMode.Upcoming,
    // from_date: fromDate,
    // to_date: toDate,
  });

  const { data: historyData, isLoading: isLoadingHistory } = useTasksListQuery({
    page: 1,
    page_size: 1000,
    mode: TaskListMode.History,
    // from_date: fromDate,
    // to_date: toDate,
  });

  const isLoading =
    isLoadingTodo || isLoadingOverdue || isLoadingUpcoming || isLoadingHistory || isDataLoading;

  const todoTotal = todoData?.pages?.[0]?.total || 0;
  const overdueTotal = overdueData?.pages?.[0]?.total || 0;
  const upcomingTotal = upcomingData?.pages?.[0]?.total || 0;
  const historyTotal = historyData?.pages?.[0]?.total || 0;

  // const { due_amount, completed_amount, upcoming_amount } = data || {};

  return (
    <AnimatedNumbersSet
      loading={isLoading}
      numbers={[
        { title: 'To do ', number: todoTotal },
        { title: 'Due', number: overdueTotal || 0 },
        { title: 'Upcoming', number: upcomingTotal || 0 },
        { title: 'Completed', number: historyTotal || 0 },
      ]}
    />
  );
};

export default CommonStatistic;
